import { adminFetch } from "./_client";
import type { FinancialReport, WinBackReport, GiftCard, GiftCardDetail, GiftBalanceReport, Coupon } from "./types";


export function fetchFinancialReport(token: string, period = "30d") {
  return adminFetch<FinancialReport>(`/admin/reports/financial?period=${period}`, token);
}


/**
 * Task #5598: declined-booking win-back KPIs. Accepts an optional explicit
 * date range (defaults to the API's own window when omitted).
 */
export function fetchWinBackReport(token: string, opts?: { since?: string; until?: string }) {
  const params = new URLSearchParams();
  if (opts?.since) params.set("since", opts.since);
  if (opts?.until) params.set("until", opts.until);
  const qs = params.toString();
  return adminFetch<WinBackReport>(`/admin/reports/win-back${qs ? `?${qs}` : ""}`, token);
}


export function fetchGiftCards(token: string, page = 1, status?: string, search?: string) {
  const params = new URLSearchParams({ page: String(page) });
  if (status) params.set("status", status);
  if (search) params.set("search", search);
  return adminFetch<{ cards: GiftCard[]; total: number }>(`/admin/gift-cards?${params}`, token);
}


export function fetchGiftCardDetail(token: string, id: number) {
  return adminFetch<GiftCardDetail>(`/admin/gift-cards/${id}`, token);
}


export function createGiftCard(token: string, data: { initial_value: number; currency?: string; recipient_email?: string; expires_at?: string }) {
  return adminFetch<GiftCard>("/admin/gift-cards", token, { method: "POST", body: JSON.stringify(data) });
}


export function bulkCreateGiftCards(token: string, data: { count: number; initial_value: number; currency?: string; expires_at?: string }) {
  return adminFetch<{ created: number; batch_id: string }>("/admin/gift-cards/bulk", token, { method: "POST", body: JSON.stringify(data) });
}


export function toggleGiftCardStatus(token: string, id: number) {
  return adminFetch<{ success: boolean; status: string }>(`/admin/gift-cards/${id}/toggle`, token, { method: "PUT" });
}


export function fetchGiftBalanceReport(token: string) {
  return adminFetch<GiftBalanceReport>("/admin/reports/gift-balance", token);
}


export function fetchPromoCodes(token: string, page = 1) {
  return adminFetch<{ codes: Coupon[]; total: number }>(`/admin/promo-codes?page=${page}`, token);
}


export function createPromoCode(token: string, data: { code: string; discount_type: string; discount_value: number; usage_limit?: number; expires_at?: string; min_order_amount?: number; currency?: string | null }) {
  return adminFetch<Coupon>("/admin/promo-codes", token, { method: "POST", body: JSON.stringify(data) });
}


export function togglePromoCode(token: string, id: number) {
  return adminFetch<{ success: boolean }>(`/admin/promo-codes/${id}/toggle`, token, { method: "PUT" });
}


export function deletePromoCode(token: string, id: number) {
  return adminFetch<{ success: boolean }>(`/admin/promo-codes/${id}`, token, { method: "DELETE" });
}
